import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';
import { useLocation, useNavigate } from 'react-router-dom';
import Pagination10 from './components/Pagination10';
import PageFooter from './components/PageFooter';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import DefaultModal from './components/modals/DefaultModal';
import ConfirmModal from './components/modals/ConfirmModal';
import usePagination10 from './components/hooks/usePagination10';
import Layout from './components/Layout';
import ResponsiveShadow from './components/ResponsiveShadow';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import Toolbar from './components/Toolbar';
import TableContainer from './components/TableContainer';
import TableHeader from './components/TableHeader';
import UsuarioVinculoModal from './components/modalServices/UsuarioVinculoModal';

function UsuariosVinculos() {
  const [Usuario, setUsuario] = useState({
    cpf: '',
    nome: '',
    login: '',
    senha: '',
    situacao: '',
    role: '',
  });
  const [UsuariosBind, setUsuariosBind] = useState([]);
  const [atualizar, setAtualizar] = useState(false);
  const [selectedVinculo, setSelectedVinculo] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingVinculo, setEditingVinculo] = useState(null);
  const location = useLocation();
  const [Clientes, setClientes] = useState([]);
  const token = localStorage.getItem('token');
  const navigate = useNavigate();
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();
  const totalItems = UsuariosBind.length;
  const { setPagination } = usePagination10(totalItems);

  // Função para gerenciar seleção/desseleção de vínculo
  const handleRowClick = vinculo => {
    // Se clicar no mesmo vínculo já selecionado, desmarca
    if (
      selectedVinculo &&
      selectedVinculo.cnpj === vinculo.cnpj &&
      selectedVinculo.cpf === vinculo.cpf
    ) {
      setSelectedVinculo(null);
    } else {
      setSelectedVinculo(vinculo);
    }
  };
  const displayedUsuarios = UsuariosBind.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  useEffect(() => {
    if (!token) {
      navigate('/');
      return;
    }

    axios
      .get(`${API_BASE_URL.CLIENTE}/all`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(result => {
        setClientes(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter listas:', error);
      });
  }, [token, navigate]);

  useEffect(() => {
    if (location.state && location.state.usuario) {
      setUsuario(location.state.usuario);
    }
  }, [location.state]);

  useEffect(() => {
    if (Usuario.cpf !== '') {
      axios
        .get(`${API_BASE_URL.USUARIO_BIND}/cpf`, {
          params: { cpf: Usuario.cpf },
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => {
          setUsuariosBind(result.data);
        })
        .catch(error => {
          console.error('Erro ao obter clientes:', error);
        });
    }
  }, [Usuario.cpf, token, atualizar]);

  function handleDelete(usuarioToDelete) {
    showConfirmModal('delete', () => handleConfirmDelete(usuarioToDelete));
  }

  function handleConfirmDelete(usuarioToDelete) {
    axios
      .delete(
        `${API_BASE_URL.USUARIO_BIND}/delete/${usuarioToDelete.cpf}/${usuarioToDelete.cnpj}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        setAtualizar(!atualizar);
        showDefaultModal('success', 'O registro foi excluído com sucesso!');
      })
      .catch(error => {
        console.error('Erro ao deletar:', error);
        showDefaultModal('error', 'Erro ao excluir o registro');
      });
  }

  function handleOpenModal(vinculo = null) {
    setEditingVinculo(vinculo);
    setIsModalOpen(true);
  }

  function handleCloseModal() {
    setIsModalOpen(false);
    setEditingVinculo(null);
  }

  function handleModalSuccess() {
    setAtualizar(prev => !prev);
    showDefaultModal('success', 'Vínculo salvo com sucesso!');
  }

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title={`Vínculos do Usuário${Usuario.nome ? ` - ${Usuario.nome}` : ''}`} icon="bi-person-lines-fill" closeRoute="/usuarios" backButton={false} />
        <PageContent style={{ paddingBottom: 0 }}>
          <Toolbar>
            <button className="btn btn-primary btn-sm me-2 px-1 py-0 fs-6" style={{ fontSize: '0.75rem' }} onClick={() => handleOpenModal()}>
              <i className="bi bi-plus me-1" />Novo
            </button>
            <button className="btn btn-secondary btn-sm me-2 px-1 py-0 fs-6" style={{ fontSize: '0.75rem' }} disabled={!selectedVinculo} onClick={() => handleOpenModal(selectedVinculo)}>
              <i className="bi bi-pencil me-1" />Editar
            </button>
            <button className="btn btn-danger btn-sm me-2 px-1 py-0 fs-6" style={{ fontSize: '0.75rem' }} disabled={!selectedVinculo} onClick={() => handleDelete(selectedVinculo)}>
              <i className="bi bi-trash me-1" />Excluir
            </button>
          </Toolbar>
      <TableContainer className="table-responsive mb-2">
        <table className="table table-striped table-hover table-sm small table-custom-radius">
          <TableHeader columns={[
            { label: 'CNPJ' },
            { label: 'Cliente/Entidade' },
            { label: 'Cidade' },
            { label: 'Tipo' },
            { label: 'Situação' },
          ]} />
          <tbody>
            {displayedUsuarios.length > 0 ? (
              displayedUsuarios.map(vinculo => {
                const isSelected =
                  selectedVinculo &&
                  selectedVinculo.cnpj === vinculo.cnpj &&
                  selectedVinculo.cpf === vinculo.cpf;
                return (
                  <tr
                    key={`${vinculo.cnpj}-${vinculo.cpf}`}
                    onClick={() => handleRowClick(vinculo)}
                    style={{ cursor: 'pointer' }}
                    className={isSelected ? 'table-active' : ''}
                    title={
                      isSelected
                        ? 'Clique novamente para desmarcar'
                        : 'Clique para selecionar'
                    }
                  >
                    <td
                      className={`px-2 ${
                        isSelected ? 'fw-bold text-primary' : ''
                      }`}
                    >
                      {vinculo.appCliente.cnpj}
                    </td>
                    <td
                      className={`px-2 ${
                        isSelected ? 'fw-bold text-primary' : ''
                      }`}
                    >
                      {vinculo.appCliente.nome}
                    </td>
                    <td
                      className={`px-2 ${
                        isSelected ? 'fw-bold text-primary' : ''
                      }`}
                    >
                      {vinculo.appCliente.logrCidade},{' '}
                      {vinculo.appCliente.logrUf}
                    </td>
                    <td
                      className={`px-2 ${
                        isSelected ? 'fw-bold text-primary' : ''
                      }`}
                    >
                      <span
                        className={`badge ${
                          vinculo.tipo === 'ADMIN' ? 'bg-danger' : 'bg-primary'
                        }`}
                      >
                        {vinculo.tipo === 'ADMIN' ? 'ADMINISTRADOR' : 'USUÁRIO'}
                      </span>
                    </td>
                    <td
                      className={`px-2 ${
                        isSelected ? 'fw-bold text-primary' : ''
                      }`}
                    >
                      <span
                        className={`badge ${
                          vinculo.situacao === 'ATIVO'
                            ? 'bg-success'
                            : 'bg-secondary'
                        }`}
                      >
                        {vinculo.situacao || 'ATIVO'}
                      </span>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="5" className="text-center text-muted py-4">
                  <i className="bi bi-person-x display-6 d-block mb-2"></i>
                  Nenhum vínculo encontrado
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </TableContainer>

      <PageFooter>
        <Pagination10 {...setPagination} />
      </PageFooter>

      <UsuarioVinculoModal
        isOpen={isModalOpen}
        vinculo={editingVinculo}
        usuario={Usuario}
        onClose={handleCloseModal}
        onSuccess={handleModalSuccess}
      />
      <DefaultModal {...setDefaultModal} />
      <ConfirmModal {...setConfirmModal} />
        </PageContent>
      </ResponsiveShadow>
    </Layout>
  );
}

export default UsuariosVinculos;
